import React from "react";

const DownLoadApp = () => {

    return (
       <div>
           <a href="https://itunes.apple.com/us/app/rklinic/id1437051698?mt=8" target="_blank" rel="noopener noreferrer" style={{ display: 'inline-block' }}>
               <img src="/images/ios.svg" style={{ marginRight: '25px' }}  alt="ios" />
           </a>
           <a href="https://play.google.com/store/apps/details?id=com.rklinic" target="_blank" rel="noopener noreferrer" style={{ display: 'inline-block' }}>
               <img src="/images/android.svg"  alt="android" />
           </a>
       </div>
    )
}


export default DownLoadApp;

